import './GoldenRecordPage.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {Breadcrumbs, Grid, Link} from "@mui/material";
import Typography from "@mui/material/Typography";
import {NavigateNext} from "@mui/icons-material";
import {useStores} from "../../stores";
import {GoldenRecordTableComponent} from "./components/GoldenRecordTableComponent";
import {SingleBarChart} from "../../components/visualization/single-barchart/SingleBarChart.tsx";
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants.ts";
import {VERTICAL_MARGIN} from "../../utils/margin.ts";
import {EXTEND_NAVIGATION_THRESHOLD} from "../../components/visualization/BarChart.tsx";
import {MainPageFacade} from "../../components/main/page/MainPageFacade.tsx";
import {CARD_CONFIG} from "../../components/dashboard/DashboardCardConfigs.tsx";

export const GoldenRecordPage: React.FC = observer(() => {
    const {goldenRecordStore} = useStores();
    const filterController = goldenRecordStore.grPageController.filterController;
    const selectionCharts = filterController.selectionCharts;
    const parentCharts = goldenRecordStore.grPageController.parentCharts;
    const dataMax = Math.max(selectionCharts?.max || 1, parentCharts?.max || 1);
    const canExtend = selectionCharts ? selectionCharts.data.length > EXTEND_NAVIGATION_THRESHOLD : false;

    const [isExtended, setIsExtended] = React.useState<boolean>(false);

    return <MainPageFacade
        title={CARD_CONFIG['golden-record'].title}
        className="golden-record-page">
        <Grid container justifyContent="start">
            <Grid size={12}>
                <Breadcrumbs separator={<NavigateNext fontSize='small'/>} aria-label='breadcrumb' className='m-2'>
                    {filterController.selectedCategory.map((category, index) =>
                        <Link key={category} href='' onClick={(e) => {
                            e.preventDefault();
                            filterController.navigateToLevel(index);
                        }}>
                            {category === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : category}
                        </Link>
                    )}
                    {filterController.hasRemainingSelectionLevels &&
                        <Typography color='textPrimary'>Select a L{filterController.selectedLevel + 1}</Typography>
                    }
                </Breadcrumbs>
            </Grid>
        </Grid>
        {selectionCharts &&
            <Grid container justifyContent="start">
                <Grid className='overview-bar-charts' size={12}>
                    {/* The bars of the bar chart */}
                    {selectionCharts.data.slice(
                        0, isExtended ? undefined : EXTEND_NAVIGATION_THRESHOLD
                    ).map(changeChartData => (
                        <div key={changeChartData.category}
                             className={`clickable bar-chart-container l${filterController.selectedLevel + 1}`}
                             onClick={() => filterController.selectNextCategoryDown(changeChartData.category)}>
                            <SingleBarChart
                                key={changeChartData.category}
                                data={{
                                    mainLabel: changeChartData.label,
                                    values: changeChartData.values,
                                }}
                                className={changeChartData.category === UNCATEGORIZED_VALUE ? ' uncat' : ''}
                                options={{
                                    width: 1300,
                                    height: 24,
                                    margin: VERTICAL_MARGIN,
                                    dataMax,
                                    labelHover: true
                                }}
                            />
                        </div>
                    ))}
                </Grid>
                <Grid size={2}/>
                <Grid size={10}>
                    {canExtend && <Typography
                        variant="h6"
                        className='clickable mt-2 mb-4'
                        onClick={() => setIsExtended(!isExtended)}
                    >
                        {isExtended ? 'Show less' : 'Show more'}
                    </Typography>}

                </Grid>
            </Grid>
        }
        <GoldenRecordTableComponent/>
    </MainPageFacade>
})